export default __webpack_public_path__ + "static/media/line.9b1653f6.svg";